/* ─── STOCK EN DIRECT SUR LES CARTES DE COLLECTION ────────────────────────────
   Le chiffre « X m² dispo » rendu par la page peut rester en retard de plusieurs
   dizaines de minutes après un blocage ou un déblocage (la copie « site » de
   Shopify ne suit pas l'engagé des commandes de blocage). On relit le
   « Disponible » auprès du backend Orak (GET /stock?ids=…, à jour), en une
   requête groupée ; repli : Storefront API (quantityAvailable) si un jeton est
   configuré. On met à jour le chiffre, data-stock (utilisé par le filtre de
   surface) et le badge de stock, comme la page l'aurait rendu avec le bon
   chiffre : rupture à 0, stock bas sous 70. Les cartes ajoutées ensuite (scroll
   infini, filtres) sont traitées au fil de l'eau. En cas d'échec, on garde
   l'affichage de la page. Seuls des textes et des classes changent : aucune
   carte n'est ajoutée, retirée ou déplacée. */
(function(){
  var BATCH = 50;
  var pending = {};
  var timer = null;

  function cardsToUpdate(root){
    var out = [];
    (root || document).querySelectorAll('.product-card[data-pid]').forEach(function(card){
      if(card.getAttribute('data-stock-live')) return;
      if(!card.querySelector('.card-stock-num')) return;
      out.push(card);
    });
    return out;
  }

  function fetchBackendBatch(ids){
    var app = (window.ORAK_APP_URL || '').replace(/\/$/, '');
    if(!app || !window.fetch || !ids.length) return Promise.resolve(null);
    return fetch(app + '/stock?ids=' + ids.map(encodeURIComponent).join(','), { cache: 'no-store' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){ return d && d.stock && typeof d.stock === 'object' ? d.stock : null; })
      .catch(function(){ return null; });
  }

  function fetchBatch(ids){
    var token = window.ORAK_SF_TOKEN, domain = window.ORAK_SF_DOMAIN;
    if(!token || !domain || !window.fetch || !ids.length) return Promise.resolve(null);
    var gids = ids.map(function(id){ return '"gid://shopify/Product/' + id + '"'; }).join(',');
    var query = '{ nodes(ids: [' + gids + ']) { ... on Product { id variants(first: 20) { nodes { quantityAvailable } } } } }';
    return fetch('https://' + domain + '/api/2025-01/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query })
    }).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        var nodes = d && d.data && d.data.nodes;
        if(!nodes) return null;
        var map = {};
        nodes.forEach(function(p){
          if(!p || !p.id || !p.variants || !p.variants.nodes) return;
          // Même calcul que la carte : somme des variantes.
          var sum = 0, seen = false;
          p.variants.nodes.forEach(function(v){
            if(typeof v.quantityAvailable === 'number'){ seen = true; sum += v.quantityAvailable; }
          });
          if(seen) map[String(p.id).split('/').pop()] = sum;
        });
        return map;
      })
      .catch(function(){ return null; });
  }

  // Badge de stock de la carte (rupture / stock bas / en stock), libellés fournis
  // par la section (window.ORAK_CARD_STOCK_L). Sans libellés, on n'y touche pas.
  function setBadge(card, kind){
    var L = window.ORAK_CARD_STOCK_L;
    if(!L || !L[kind]) return;
    var b = card.querySelector('.card-badges .badge-out, .card-badges .badge-low, .card-badges .badge-stock');
    if(!b || b.classList.contains('badge-' + kind)) return;
    b.className = 'badge badge-' + kind;
    b.textContent = L[kind];
  }

  function setOut(card){
    var L = window.ORAK_CARD_STOCK_L;
    if(!L || !L.outText) return;
    card.classList.add('is-out');
    setBadge(card, 'out');
    var info = card.querySelector('.card-stock-info');
    if(info){ info.className = 'card-stock-info out'; info.textContent = L.outText; }
  }

  function apply(map, cards){
    if(!map) return;
    Object.keys(map).forEach(function(pid){
      var n = map[pid];
      if(typeof n !== 'number' || !isFinite(n)) return;
      (cards[pid] || []).forEach(function(card){
        card.setAttribute('data-stock', Math.max(0, n));
        if(n > 0){
          var num = card.querySelector('.card-stock-num');
          if(num) num.textContent = n;
          setBadge(card, n < 70 ? 'low' : 'stock');
        } else {
          setOut(card);
        }
      });
    });
  }

  function flush(){
    timer = null;
    var cards = pending;
    pending = {};
    var ids = Object.keys(cards);
    for(var i = 0; i < ids.length; i += BATCH){
      (function(batch){
        fetchBackendBatch(batch)
          .then(function(map){ return map || fetchBatch(batch); })
          .then(function(map){ apply(map, cards); });
      })(ids.slice(i, i + BATCH));
    }
  }

  function queue(root){
    cardsToUpdate(root).forEach(function(card){
      card.setAttribute('data-stock-live', '1');
      var pid = card.getAttribute('data-pid');
      (pending[pid] = pending[pid] || []).push(card);
    });
    if(!timer && Object.keys(pending).length) timer = setTimeout(flush, 150);
  }

  function init(){
    queue(document);
    if(!window.MutationObserver) return;
    // Cartes ajoutées plus tard (scroll infini, chargement complet pour les filtres).
    var mo = new MutationObserver(function(muts){
      for(var i = 0; i < muts.length; i++){
        if(muts[i].addedNodes && muts[i].addedNodes.length){ queue(document); return; }
      }
    });
    document.querySelectorAll('.products-grid, #productsGrid, [data-products-grid]').forEach(function(g){
      mo.observe(g, { childList: true });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
